import { FileObject } from "@citychallenge/common";

interface RemoteFileObject extends FileObject {
  convertedFilePath?: string;
}

export function getRemoteFile(file: RemoteFileObject | undefined) {
  if (file?.convertedFilePath) return file?.convertedFilePath;

  return getRemoteFileOriginal(file);
}

export const useRemoteFile = (file: RemoteFileObject | undefined) => {
  return getRemoteFile(file);
};

export function getRemoteFileOptimized(file: RemoteFileObject | undefined) {
  if (file?.convertedFilePath) return file?.convertedFilePath;
  if (file?.optimizedFilePath) return file.optimizedFilePath;

  return getRemoteFileOriginal(file);
}

export const useRemoteFileOptimized = (file: RemoteFileObject | undefined) => {
  return getRemoteFileOptimized(file);
};

export function getRemoteFileOriginal(file: RemoteFileObject | undefined) {
  if (file?.originalFilePath) return file.originalFilePath;

  return file?.path;
}

export function useRemoteFileOriginal(file: RemoteFileObject | undefined) {
  return getRemoteFileOriginal(file);
}
